import React from "react";
import { Dropdown } from "semantic-ui-react";
import { Link, useHistory } from "react-router-dom";

export default function SectionDropdown(params) {
    const history = useHistory();

    const pagesOptions = [
        {
            key: "index",
            text: params.page === "index" ? "Overview (selected)" : "Overview",
            value: "index",
        },
        {
            key: "clubs",
            text:
                params.page === "clubs"
                    ? "Golf Clubs (selected)"
                    : "Golf Clubs",
            value: "clubs",
        },
        {
            key: "courses",
            text:
                params.page === "courses"
                    ? "Golf Courses (selected)"
                    : "Golf Courses",
            value: "courses",
        },
        {
            key: "teetimes",
            text:
                params.page === "teetimes"
                    ? "Tee Times (selected)"
                    : "Tee Times",
            value: "teetimes",
        },
        {
            key: "members",
            text: params.page === "members" ? "Members (selected)" : "Members",
            value: "members",
        },
    ];

    const onPageChange = (e, { value }) => {
        if (value === "clubs") {
            history.push("/public/api-documentation/v2/clubs");
        } else if (value === "courses") {
            history.push("/public/api-documentation/v2/courses");
        } else if (value === "teetimes") {
            history.push("/public/api-documentation/v2/teetimes");
        } else if (value === "members") {
            history.push("/public/api-documentation/v2/members");
        } else {
            history.push("/public/api-documentation/v2");
        }
    };

    return (
        <div className='row mt-4'>
            <div
                className='col-12'
                style={{ display: "flex", justifyContent: "flex-end" }}
            >
                <Dropdown
                    selection
                    options={pagesOptions}
                    onChange={onPageChange}
                    value={params.page}
                />
            </div>
        </div>
    );
}
